import { render, staticRenderFns } from "./alertData.vue?vue&type=template&id=5bc12ee8&scoped=true&"
import script from "./alertData.vue?vue&type=script&lang=js&"
export * from "./alertData.vue?vue&type=script&lang=js&"
import style0 from "./alertData.vue?vue&type=style&index=0&id=5bc12ee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc12ee8",
  null
  
)

export default component.exports